// extracted by mini-css-extract-plugin
export default {"details":"_3krhHSfFw1","details-dropdown":"FeBfx6eb9h","detailsDropdown":"FeBfx6eb9h","details-button":"_2kTlhkWX6M","detailsButton":"_2kTlhkWX6M"};
    if(module.hot) {
      // 1633091603617
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  